import { useYjsStore } from './useYjs';

export function useCurrentDocument() {
  return useYjsStore(state => state.yjsDocument);
}
